import {
  ACTION_ARGS,
  Arg,
  COMPONENT_STATE_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import { CENTER } from '../../../../utils/spds/constants/css-layout';
import { on } from '@ember/modifier';
import CoreInput from '../../core/input.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Individual button within a segmented control group',
  extends: [
    pick(ACTION_ARGS, ['onClick']),
    pick(COMPONENT_STATE_ARGS, ['disabled']),
    pick(CONTENT_ARGS, ['iconOnly']),
    pick(FLEX_ARGS, [{ name: 'alignItems', default: CENTER }]),
  ],
  meta: {
    groupName: Arg.string({ description: 'Name attribute for the radio group' }),
  },
  name: 'Segmented Control Button',
});

export default class SpdsActionSegmentedControlButton extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-segmented-control-button';
  classesToMapToArgs = ['iconOnly'];

  get alignItems() {
    return this.argOrDefault('alignItems');
  }

  get justifyContent() {
    return this.argOrDefault('justifyContent');
  }

  get labelId() {
    return this.composeSubcomponentId('label');
  }

  <template>
    <CoreInput
      @disabled={{@disabled}}
      @id={{this.id}}
      @name={{@groupName}}
      @type="radio"
      class={{this.classes}}
      data-test-spds-action-segmented-control-button
      {{on "click" @onClick}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
    />
    <FlexRow
      @alignItems={{this.alignItems}}
      @inline={{true}}
      @justifyContent={{this.justifyContent}}
      @tag="label"
      class="spds-action-segmented-control-button-label"
      data-test-spds-action-segmented-control-button-label
      for={{this.id}}
      id={{this.labelId}}
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const ACTION_SEGMENTED_CONTROL_BUTTON_METADATA = SpdsActionSegmentedControlButton.metadata;
